export interface Validator {
    validate: () => undefined | ValidationError;
}

export interface ValidationError {
    field?: string;
    message: string;
}

export class MinLengthValidator implements Validator {
    private constructor(private value: string, private minLength: number, private message: string) {
    }

    static ofValueMinLengthAndMessage(value: string, minLength: number, message: string) {
        return new MinLengthValidator(value, minLength, message);
    }

    validate() {
        if (this.value && this.value.toString().length > 0) {
            return this.value.toString().length < this.minLength ? {message: this.message} : undefined
        }
    }
}

export class EmailValidator implements Validator {

    private emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    private constructor(private value: string, private message: string) {
    }

    static ofValueAndMessage(value: string, message: string) {
        return new EmailValidator(value, message);
    }

    validate() {
        if (this.value) {
            return !this.emailRegexp.test(this.value) ? {message: this.message} : undefined;
        }
    }
}

export class RequiredValidator implements Validator {

    private constructor(private value: unknown, private message: string) {
    }

    static ofValueAndMessage(value: unknown, message: string) {
        return new RequiredValidator(value, message);
    }

    validate() {
        return !this.value ? {message: this.message} : undefined;
    }

}

export class PhoneValidator implements Validator {

    private phoneExpression = /^[+]?[0-9]+$/;

    private constructor(private value: string, private message: string) {
    }

    static ofValueAndMessage(value: string, message: string) {
        return new PhoneValidator(value, message);
    }

    validate() {
        if (this.value) {
            return !this.phoneExpression.test(this.value) ? {message: this.message} : undefined;
        }
    }
}

export interface Validators {
    field: string;
    validators: Validator[];
}

export class ValidationAggregator {
    private constructor(private validators: Validators[]) {
    }

    static of(validators: Validators[]) {
        return new ValidationAggregator(validators);
    }

    getErrors(): ValidationError[] {
        const validationErrors = [] as ValidationError[];
        this.validators.forEach((field) => {

            field.validators.forEach(validator => {
                const message = validator.validate()?.message;

                if (message && !this.fieldHasError(field.field, validationErrors)) {
                    const validationError = {message: message, field: field.field};
                    validationErrors.push(validationError)
                }
            })
        });
        return validationErrors;
    }

    fieldHasError(field: string, validationErrors: ValidationError[]): boolean {
        return !!validationErrors.find(validationError => validationError.field === field)
    }

}
